import { InjectionToken } from "@angular/core";

export const PROD_TOKEN = new InjectionToken<boolean>('prod');
export const API_URL_TOKEN = new InjectionToken<string>('ApiUrl');
export const API_AUTH_URL = new InjectionToken<string>('AuthURL');
export const CLIENT_PORTAL_URL = new InjectionToken<string>('clientPortalUrl');
